import IconoTrazo from '@/components/marketing/comun/IconoTrazo';
import { SELLOS_PRECIOS, type VistaPrecios } from './textosSeccionPrecios';

/** La fila de sellos bajo las tarjetas: 3 en «Para ti» y 2 en «Para tu clínica» (UI-SPEC §Interaction 5). */
export default function SellosPrecios({ vista }: { vista: VistaPrecios }) {
    const sellos = SELLOS_PRECIOS.filter((sello) => vista === 'individual' || !sello.soloIndividual);
    return (
        <ul
            data-sellos
            className="m-0 flex list-none flex-col flex-wrap justify-center gap-2.5 p-0 lg:flex-row lg:gap-3.5"
        >
            {sellos.map((sello) => (
                <li
                    key={sello.texto}
                    className="flex items-center gap-2.5 rounded-ds-md border-2 border-ink bg-surface-2 px-3.5 py-2.5 text-ds-200 font-semibold leading-[1.4]"
                >
                    <IconoTrazo trazo={sello.trazo} tamano={18} className="shrink-0 text-ink" />
                    {sello.texto}
                </li>
            ))}
        </ul>
    );
}
